import { call, put, takeEvery, all, fork } from "redux-saga/effects";

import {
    CREATE_MSTEAMS_CHANNEL,
    GET_MSTEAMS_CHANNELS,
    DELETE_MSTEAMS_CHANNEL
} from "./actionTypes";

import {
    createMsTeamsChannelSuccess,
    createMsTeamsChannelFail,
    getMsTeamsChannelsSuccess,
    getMsTeamsChannelsFail,
    deleteMsTeamsChannelSuccess,
    deleteMsTeamsChannelFail
} from "./actions";

import {
    createMSTeamsChannelUrl,
    getMSTeamsChannelsUrl,
    deleteMsTeamsChannelUrl
} from "../../helpers/fakebackend_helper";

import { showNotification } from "components/Common/notification";


function* createMsTeamsChannel({ payload }) {
    try {
        const response = yield call(createMSTeamsChannelUrl, payload);
        yield put(createMsTeamsChannelSuccess(response));
        showNotification("success", "Ms Teams Channel Created Successfully");
        // Wait for 2 seconds and redirect
        yield new Promise(resolve => setTimeout(resolve, 2000));
        window.location.href = "/dashboard"
    } catch (error) {
        yield put(createMsTeamsChannelFail(error));
        showNotification("error", "Ms Teams Channel Creation Failed");
    }
}


function* getMsTeamsChannels() {
    try {
        const response = yield call(getMSTeamsChannelsUrl);
        yield put(getMsTeamsChannelsSuccess(response));
    } catch (error) {
        yield put(getMsTeamsChannelsFail(error));
    }
}


function* deleteMsTeamsChannel({ payload }) {
    try {
        const response = yield call(deleteMsTeamsChannelUrl, payload);
        yield put(deleteMsTeamsChannelSuccess(response));
        showNotification("success", "Ms Teams Channel Deleted Successfully");
        // Wait for 2 seconds and redirect
        yield new Promise(resolve => setTimeout(resolve, 2000));
        window.location.href = "/msteams/list"
    }
    catch (error) {
        yield put(deleteMsTeamsChannelFail(error));
        showNotification("error", "Ms Teams Channel Deletion Failed");
    }
}


function* msTeamsSaga() {
    yield takeEvery(CREATE_MSTEAMS_CHANNEL, createMsTeamsChannel);
    yield takeEvery(GET_MSTEAMS_CHANNELS, getMsTeamsChannels);
    yield takeEvery(DELETE_MSTEAMS_CHANNEL, deleteMsTeamsChannel);
}

export default msTeamsSaga;
